import React, { useEffect } from "react";
import { Card, Row, Col, Form, Input } from "antd";
import 'antd/dist/antd.css';



const SocialNetworksList = ({ socialAccounts }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        socialAccounts.map((elm, index) => (
            form.setFieldsValue({
                ["account_name_" + elm.name]: elm.account_name,
                ["user_url_" + elm.name]: elm.user_url
            })
        ))
    }, [form, socialAccounts]);


    return (
        <>
            <Form
                form={form}
                labelCol={{ span: 6 }}
                labelAlign="left"
                wrapperCol={{ span: 18 }}
                layout="horizontal"
            >
                <Row gutter={24} className='mt-3 '>

                    {(socialAccounts.map((elm, index) => (
                        <Col xl={24} lg={24} md={24} sm={24} xs={24} key={index}>
                            <Card style={{ borderRadius: "10px" }} className={index !== 0 && "mt-2"} bodyStyle={{ padding: "15px" }}>
                                <Row gutter={24} className="p-0 m-0" align="middle">
                                    <Col xl={4} lg={4} md={4} sm={24} xs={24} className="p-0 m-0">
                                        {elm.name === 'Facebook' ? (
                                            <img src="/img/fb-logo.png" alt="Facebook Logo" style={{ width: "100%", height: "100px", borderRadius: "15px" }} />
                                        ) : elm.name === 'Twitter' ? (
                                            <img src="/img/twitter-logo.png" alt="Twitter Logo" style={{ width: "100%", height: "100px", borderRadius: "15px" }} />
                                        ) : elm.name === 'Instagram' && (
                                            <img src="/img/instagram-logo.png" alt="Instagram Logo" style={{ width: "100%", height: "100px", borderRadius: "15px" }} />
                                        )}
                                    </Col>
                                    <Col xl={2} lg={2} md={2} sm={24} xs={24}></Col>
                                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item name={"account_name_" + elm.name} label="Emri i llogarisë:" className="p-0 m-0 mt-2">
                                            <Input type="text" disabled />
                                        </Form.Item>
                                        <Form.Item name={"user_url_" + elm.name} label="User url:" className="p-0 m-0 mt-2">
                                            <Input type="text" disabled />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    )))}
                </Row>
            </Form>
        </>
    );
};

export default SocialNetworksList;

